<template>
  <div class="horizontal">
    <div v-for="product in products" :key="product.id" class="product col-lg-3 col-md-4 col-sm-6 cl-xs-12">
      <router-link :to="{ name: 'Product', params: { productId: product.id }}">
        <div class="image"><img :src="product.imageUrl"/></div>
        <p class="name mt-0">{{ product.name }}</p>
        <p class="price mb-1"><strong>{{ pointsDisplayed(product.points, product.taxPoints) | numToLocale }}</strong> points</p>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      currentPage: 0,
    }
  },
  computed: {
    ...mapState({
      grossUpTaxes: state => state.company.grossUpTaxes,

      products: state => state.product.hotItems,
    }),
    hasPrevious: function () { return this.currentPage > 0},
    hasNext: function () { return this.products.length === 20},
  },
  methods: {
    pointsDisplayed: function (productPoints, taxPoints) {
      if (this.grossUpTaxes) {
        return productPoints + taxPoints
      } else {
        return productPoints
      }
    },
  },
  created () {
    this.$store.dispatch('product/fetchHotProducts', {
      page: this.currentPage,
    })
  }
}
</script>

<style lang="scss" scoped>
.horizontal{
  font-size: 80%;
}
.product{
  .image{
    width: 40%;
    float: left;
    margin-right: 16px;
    height: auto;
    img{
      max-width: 180px;
      vertical-align: middle;
      width: 100%;
      height: auto;
    }
  }
}
@media all and (max-width: 450px){
  .horizontal{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: scroll;
  }
  .product{
    .image{
      width: 150px;
      float: left;
      margin-right: 16px;
      height: 150px;
      img{
        max-width: 150px;
        vertical-align: middle;
      }
    }
  }
}
</style>
